export default __webpack_public_path__ + "static/optimization-illustration-9d0316250e20c1cc864e2895ac5c36de.svg";